import { SortDirections } from "./Misc";

export enum ScenarioSortAttributes {
	Name = "name",
	DatePublished = "publishedAt"
}

export interface IWorklinkSettings
{
	scenarioList: IWorklinkScenarioListSettings;
}

export interface IWorklinkScenarioListSettings
{
	pageSize: number;
	sortingMethod: SortDirections;
	sortingAttribute: ScenarioSortAttributes;
}